module.exports = __webpack_public_path__ + "img/preview.656bcf42.svg";